import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const ChatAssignment = () => {
  const [isAutoAssignEnabled, setIsAutoAssignEnabled] = useState(false);

  return (
    <div
      className="container-fluid mt-4 p-4 border rounded"
      style={{ maxHeight: "85vh", overflow: "auto" }}
    >

      <div className="d-flex align-items-center justify-content-between row border-bottom">
        <div className="d-flex align-items-center justify-content-between row border-bottom ">
          <div className="mb-3 d-flex align-items-center col-md-8">

            <div className="me-3">
              <h2 className="m-0">
                <i className="bi bi-chat-quote-fill"></i>
              </h2>
            </div>


            <div className="header-text-content">
              <h6 className="m-0">Chat Assignment</h6>
              <p className="small m-0">
                When enabled, conversations will be assigned to agents based on
                the applied filters.
              </p>
            </div>
          </div>
        </div>


        <div className="d-flex justify-content-between align-items-center border rounded p-3 mt-3 bg-light">
          <span className="fw-bold">Enable Auto Assignment of chats</span>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              checked={isAutoAssignEnabled}
              onChange={() => setIsAutoAssignEnabled(!isAutoAssignEnabled)}
              disabled 
            />
          </div>
        </div>
      </div>


      <div className="d-flex flex-column align-items-center mt-5">
        <i className="bi bi-chat-left-text fs-1 text-muted"></i>
        <p className="text-muted mt-2">Assign chats to agents conditionally</p>
        <button className="btn btn-success">Create Chat Assignment</button>
      </div>
    </div>
  );
};

export default ChatAssignment;
